import { useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

// Helper functions moved to outer scope for better performance
function handleClickLang(lang) {
  i18next.changeLanguage(lang);
}

const Footer = () => {
  const footerStyle = {
    backgroundColor: 'rgba(240, 240, 240, 0.7)',
    padding: '10px',
    textAlign: 'center',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: '40px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backdropFilter: 'blur(5px)',
  };
  const itemStyle = {
    margin: '0 10px',
    height: '20px',
  };

  const { t } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const handleClickLangs = (language) => {
    setSelectedLanguage(language);
    i18next.changeLanguage(language);
  };

  return (
    <footer style={footerStyle}>
      {}
      <a href="https://chainsmart.id" target="_blank" rel="noopener noreferrer" style={{ paddingLeft: '18em' }}>
        &copy; 2024 ChainSmart - All Rights Reserved
      </a>
      <ToggleButtonGroup
        style={itemStyle}
        color="primary"
        value={selectedLanguage}
        exclusive
        aria-label="Language Toggle"
      >
        <ToggleButton value="en" onClick={() => handleClickLangs('en')}>
          EN
        </ToggleButton>
        <ToggleButton value="id" onClick={() => handleClickLangs('id')}>
          ID
        </ToggleButton>
      </ToggleButtonGroup>
    </footer>
  );
};

export default Footer;
